<template>
  <div>
    <div class="newbg_img">
      <img src='~@/common/img/new1.jpg'>
    </div>
    <div id="news">
      <div>
        <Thenewtype :list="newstype" @_fromType="_newsType"></Thenewtype>
        <Thenewlist :list="newslist" :total="total" @_fromPage='_newsPage'></Thenewlist>
      </div>
      <div>
        <Thehotlist v-if="hotlist.length" :list="hotlist"></Thehotlist>
      </div>
    </div>
  </div>

</template>


<script>
import Thenewtype from './list/newtype';
import Thenewlist from './list/newlist';
import Thehotlist from './list/hotlist';
import { getType, getInfoListShow, getInfoHot } from '@/api/portal';
export default {
  data() {
    return {
      newstype: [], //资讯类型
      newslist: [], //资讯列表
      hotlist: [], //热点新闻
      type: '',
      page_index: 1,
      page_size: 10,
      total: 0,
    };
  },
  components: {
    Thenewlist,
    Thenewtype,
    Thehotlist,
  },
  watch: {
    type() {
      this._getList();
    },
    page_index() {
      this._getList();
    },
  },
  methods: {
    //获取资讯类型
    _getNewsType() {
      getType({ action: 'news.info.getType' })
        .then(res => {
          if (res.state == 1) {
            this.newstype = [
              {
                key: '',
                value: '全部资讯',
              },
              ...res.data,
            ];
          }
        })
        .catch(err => {});
    },
    //获取新闻列表
    _getList() {
      getInfoListShow({
        action: 'news.info.getInfoListShow',
        type: this.type,
        page_index: this.page_index,
        page_size: this.page_size,
      })
        .then(res => {
          this.total = res.total_count;
          if (res.state == 1) {
            var list = res.data;
            if (list.length) {
              //重新组装数组
              var arr = [];
              var index = '';
              for (var i = 0, leng = list.length; i < leng; i += 1) {
                if (list[i].list_image) {
                  index = i;
                  break;
                }
              }
              index = Number(index);
              arr.push(list[index]);
              arr.push.apply(arr, list.slice(0, index));
              arr.push.apply(arr, list.slice(index + 1, list.length));
              this.newslist = arr;
            } else {
              this.newslist = list;
            }
          }
        })
        .catch(err => {});
    },
    //获取热点资讯
    _gethotlist() {
      getInfoHot({
        action: 'news.info.getInfoHot',
        page_index: 1,
        page_size: 3,
      })
        .then(res => {
          this.hotlist = res.data;
        })
        .catch(err => {});
    },
    //子组件传参
    _newsType(data) {
      this.type = data;
    },
    _newsPage(val) {
      this.page_index = val;
    },
  },
  mounted() {
    this._getNewsType();
    this._getList();
    this._gethotlist();
  },
};
</script>


<style scoped>
#news {
  width: 1180px;
  margin: 0 auto;
  padding-top: 48px;
}
.newbg_img img {
  max-height: 400px;
  width: 100%;
  max-width: 100%;
}
#news > div {
  display: inline-block;
  vertical-align: top;
}
#news > div:first-child {
  width: 776px;
}
#news > div:last-child {
  width: 276px;
  margin-left: 120px;
}
</style>
